import { Component, OnDestroy, inject } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from './../service/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: true,
  imports: [ProgressSpinnerModule],
})
export class LoadingComponent implements OnDestroy {
  private service = inject(LoadingService);

  loading: boolean = false;

  constructor() {
    setTimeout(() => {
      this.service.onLoadingChanged.subscribe(
        (isLoading: boolean) => (this.loading = isLoading),
      );
    });
  }

  ngOnDestroy(): void {
    this.loading = false;
  }
}
